(function () {
  function openDialog(dialog) {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function initProduct(root) {
    if (root.dataset.scartTransmissionReady === 'true') return;

    var form = document.getElementById(root.dataset.formId);
    var dialog = root.querySelector('.scart-transmission-dialog');
    if (!form || !dialog) return;

    root.dataset.scartTransmissionReady = 'true';
    var confirmButton = root.querySelector('[data-scart-transmission-confirm]');
    var submitButton = form.querySelector('[name="add"]');

    form.addEventListener(
      'submit',
      function (event) {
        if (root.querySelector('[data-scart-transmission-option]:checked')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openDialog(dialog);
      },
      true
    );

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-scart-transmission-option]')) {
        confirmButton.disabled = false;
      }
    });

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-scart-transmission-close]')) {
        closeDialog(dialog);
        return;
      }

      if (event.target.closest('[data-scart-transmission-confirm]')) {
        if (!root.querySelector('[data-scart-transmission-option]:checked')) return;
        closeDialog(dialog);
        form.requestSubmit(submitButton);
      }
    });
  }

  function bootProducts(scope) {
    var roots = (scope || document).querySelectorAll('[data-scart-transmission-product]');
    for (var i = 0; i < roots.length; i++) initProduct(roots[i]);
  }

  async function saveCartTransmission(root, input) {
    if (root.dataset.scartTransmissionSaving === 'true') return;
    root.dataset.scartTransmissionSaving = 'true';

    var status = root.querySelector('[data-scart-transmission-status]');
    var isFrench = document.documentElement.lang.toLowerCase().indexOf('fr') === 0;
    var properties = JSON.parse(root.dataset.properties || '{}');
    properties[isFrench ? 'Boîte de vitesses' : 'Transmission'] = input.value;
    if (status) status.textContent = isFrench ? 'Enregistrement…' : 'Saving…';

    try {
      var cartDrawer = document.querySelector('cart-drawer');
      var body = {
        id: root.dataset.lineKey,
        properties: properties,
      };

      if (cartDrawer) {
        body.sections = cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        });
        body.sections_url = window.location.pathname;
      }

      var response = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      });
      var cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'Cart update failed');

      if (cartDrawer && cart.sections) {
        cartDrawer.renderContents(cart);
      } else {
        window.location.reload();
      }
    } catch (error) {
      root.dataset.scartTransmissionSaving = 'false';
      if (status) {
        status.textContent = isFrench
          ? "Impossible d'enregistrer. Réessayez."
          : 'Unable to save. Please try again.';
      }
      input.checked = false;
      console.error(error);
    }
  }

  if (!window.scartTransmissionCartReady) {
    window.scartTransmissionCartReady = true;
    document.addEventListener('change', function (event) {
      var root = event.target.closest('[data-scart-transmission-cart]');
      if (root && event.target.matches('input[type="radio"]')) {
        saveCartTransmission(root, event.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootProducts(document);
    });
  } else {
    bootProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootProducts(event.target);
  });
})();
